import React from "react";

export default function MSAccess_WeekdayName() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_WeekdayName</h1>
      <p>This is the MSAccess_WeekdayName component generated from the SQL JSON.</p>
    </div>
  );
}
